import Stat from './Stat';

export type { StatProps } from './Stat';
export default Stat;
